<head><meta name="viewport" content="width=device-width, initial-scale=1.0"></head>
<!-- <body> -->
<!-- <table>
  <tr>
    <th>Name</th>
    <th>Dosage</th> 
    <th>Validity</th>
  </tr>
  <tr>
    <td></td>
    <td></td> 
    <td></td>
  </tr>
  <tr>
    <td></td>
    <td></td> 
    <td></td>
  </tr>
</table> -->
<!-- Button to open prescription form -->
<button class="form-control" onclick="document.getElementById('id01').style.display='block'">Add Prescription</button>

<!-- The Modal -->
<div id="id01" class="modal">
  <span onclick="document.getElementById('id01').style.display='none'" 
class="close" title="Close Modal">&times;</span>

  <!-- Modal Content -->
  <form class="modal-content animate" >
    <div class="imgcontainer">
     Add new prescription
    </div>

    <div class="container">
      <label for="uname"><b>Name</b></label>
      <input type="text" placeholder="Provide a name" name="uname" required>

        <label for="comment">Dosage</label>
        <textarea class="form-control" rows="5" id="comment"></textarea>

        <label for="comment">Validity</label>
        <textarea class="form-control" rows="5" id="comment"></textarea>
     

      <button routerLink="../prescription" type="submit">Submit</button>
      
    </div>


  </form>
</div>

<!-- </body> -->